import React from 'react';
import { Descriptions } from 'antd';
import { Owner } from '../../models';

const PropertyOwnerDescriptions: React.FC<{
  owners: Owner[];
}> = (props: { owners: Owner[] }) => {
  const { owners } = props;

  return (
    <Descriptions
      title="Property Owner Name Information"
      bordered
      size={'small'}
    >
      {owners.map((item, index) => (
        <Descriptions.Item key={index} label="Owner">
          {item.name}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
};

export default PropertyOwnerDescriptions;
